// extracted by css-extract-rspack-plugin
export default {"textBox":"Search__textBox--2Ui4A","textBoxWrap":"Search__textBoxWrap--mHkWw","icon":"Search__icon--xeWrn"};